/**
 * B.S.C. Laboratories — cart-level 21+ confirmation guard.
 *
 * This store is on Shopify Basic, so theme code cannot inject a required field into
 * Shopify's native hosted checkout pages. This script instead gates the storefront
 * side: it disables the cart page / cart drawer "Checkout" button (id="checkout" in
 * the Horizon base theme) and any accelerated checkout buttons (Shop Pay, PayPal, etc.)
 * until the visitor checks the 21+ confirmation box. It does not claim to be an
 * identity-verified check, and it cannot enforce anything once a customer reaches
 * Shopify's own checkout pages.
 *
 * Because Horizon re-renders cart markup via a client-side "morph" on every cart
 * change (quantity update, discount apply, etc.), this script uses a MutationObserver
 * to re-inject the checkbox/message and re-apply the disabled state after every render,
 * and remembers the confirmed state for the current tab session only.
 */
(function () {
  var STORAGE_KEY = 'bscCartAgeConfirmed';
  var confirmed = false;
  try {
    confirmed = sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    /* ignore */
  }

  var LABEL_HTML =
    '<div class="bsc-cart-age-confirm" data-bsc-cart-guard>' +
    '<input type="checkbox" id="bsc-cart-age-checkbox" data-bsc-cart-age-checkbox />' +
    '<label for="bsc-cart-age-checkbox">I confirm that I am at least 21 years old and eligible to purchase from B.S.C. Laboratories. ' +
    '<a href="/pages/age-restriction-policy">Age Restriction Policy</a></label>' +
    '</div>' +
    '<p class="bsc-cart-age-inline-message" data-bsc-cart-age-message>Please confirm you are 21 or older before continuing to checkout.</p>';

  function findTargets(root) {
    var checkoutButtons = root.querySelectorAll('#checkout, [name="checkout"]');
    var ctas = root.querySelectorAll('.cart__ctas');
    return { checkoutButtons: checkoutButtons, ctas: ctas };
  }

  function applyState(root) {
    var targets = findTargets(root);
    targets.checkoutButtons.forEach(function (btn) {
      if (btn.dataset.bscEmptyDisabled === undefined) {
        btn.dataset.bscEmptyDisabled = btn.disabled ? 'true' : 'false';
      }
      var emptyDisabled = btn.dataset.bscEmptyDisabled === 'true';
      btn.disabled = emptyDisabled || !confirmed;
    });

    var messages = root.querySelectorAll('[data-bsc-cart-age-message]');
    messages.forEach(function (msg) {
      msg.setAttribute('data-visible', confirmed ? 'false' : 'false');
    });

    var checkboxes = root.querySelectorAll('[data-bsc-cart-age-checkbox]');
    checkboxes.forEach(function (cb) {
      cb.checked = confirmed;
    });
  }

  function injectInto(ctas) {
    if (ctas.querySelector('[data-bsc-cart-guard]')) return;
    ctas.insertAdjacentHTML('beforebegin', LABEL_HTML);
  }

  function processRoot(root) {
    var targets = findTargets(root);
    targets.ctas.forEach(injectInto);
    applyState(root);
  }

  function processDocument() {
    processRoot(document);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-bsc-cart-age-checkbox]')) {
      confirmed = e.target.checked;
      try {
        sessionStorage.setItem(STORAGE_KEY, confirmed ? 'true' : 'false');
      } catch (err) {
        /* ignore */
      }
      applyState(document);
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      var ctas = e.target.closest ? e.target.closest('.cart__ctas') : null;
      if (!ctas || confirmed) return;
      var isControl = e.target.closest('#checkout, .additional-checkout-buttons, .additional-checkout-buttons *');
      if (!isControl) return;
      e.preventDefault();
      e.stopPropagation();
      var msg = ctas.parentElement ? ctas.parentElement.querySelector('[data-bsc-cart-age-message]') : null;
      if (!msg) msg = document.querySelector('[data-bsc-cart-age-message]');
      if (msg) msg.setAttribute('data-visible', 'true');
    },
    true
  );

  processDocument();


})();
